import moment from 'moment';

import { Http } from '../../../support';

const availlableTypes = ['timbrado-comprobantes', 'timbrado-nomina', 'timbrado-pagos'];

const from = moment().subtract(1, 'month').format('YYYY-MM-DD');
const to = moment().format('YYYY-MM-DD');

export const initialState = {
  busy: false,
  actionBusy: false,
  data: [],
  selectedRows: [],
  selectedRowKeys: [],
  result: undefined,
  error: undefined,
  pagination: {
    limit: 25,
    from,
    to,
    tipo: [...availlableTypes],
  },
};

const setSelectedRows = (store, data) => {
  store.setState((state) => {
    state.modulo.timbrado_masivo.archivos = {
      ...state.modulo.timbrado_masivo.archivos,
      ...data,
    };
  });
};

const download = async (store, selectedRowKeys, original = undefined) => {
  store.setState((state) => {
    state.modulo.timbrado_masivo.archivos.actionBusy = true;
  });

  try {
    const params = {
      as: 'link',
      original: original,
    };

    const response = await Http.get(`${window.BONJOUR_URL}/api/timbrado-masivo/comprobantes/${selectedRowKeys[0]}`, {
      params,
    });

    window.location = response.data.link;

    store.setState((state) => {
      state.modulo.timbrado_masivo.archivos.actionBusy = false;
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.timbrado_masivo.archivos.actionBusy = false;
      state.modulo.timbrado_masivo.archivos.error = error.data || error;
    });
  }
};

const downloadCfdis = async (store, selectedRowKeys) => {
  store.setState((state) => {
    state.modulo.timbrado_masivo.archivos.actionBusy = true;
  });

  try {
    const params = {
      as: 'link',
    };

    const response = await Http.get(
      `${window.BONJOUR_URL}/api/timbrado-masivo/comprobantes/${selectedRowKeys[0]}/cfdis`,
      { params }
    );

    window.location = response.data.link;

    store.setState((state) => {
      state.modulo.timbrado_masivo.archivos.actionBusy = false;
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.timbrado_masivo.archivos.actionBusy = false;
      state.modulo.timbrado_masivo.archivos.error = error.data || error;
    });
  }
};

const change = (store, data) => {
  store.setState((state) => {
    state.modulo.timbrado_masivo.archivos.data = {
      ...state.modulo.timbrado_masivo.archivos.data,
      ...data,
    };
  });
};

const paginate = async (store, params) => {
  store.setState((state) => {
    state.modulo.timbrado_masivo.archivos = {
      ...state.modulo.timbrado_masivo.archivos,
      result: undefined,
      error: undefined,
      busy: true,
      pagination: {
        ...state.modulo.timbrado_masivo.archivos.pagination,
        ...params,
        links: undefined,
      },
    };
  });

  try {
    const { pagination } = store.state.modulo.timbrado_masivo.archivos;

    const body = {
      ...pagination,
      ...params,
      tipo: params.tipo === null ? [...availlableTypes] : params.tipo || pagination.tipo || [...availlableTypes],
    };
    const response = await Http.get(`/api/excel-files`, { params: body });

    store.setState((state) => {
      state.modulo.timbrado_masivo.archivos = {
        ...state.modulo.timbrado_masivo.archivos,
        busy: false,
        data: response.data,
        pagination: {
          ...state.modulo.timbrado_masivo.archivos.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.timbrado_masivo.archivos.busy = false;
      state.modulo.timbrado_masivo.archivos.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.modulo.timbrado_masivo.archivos = {
      ...initialState,
    };
  });
};

const TimbradoMasivoListStore = {
  state: () => initialState,
  actions: {
    change,
    download,
    downloadCfdis,
    setSelectedRows,
    paginate,
    reset,
  },
};

export default TimbradoMasivoListStore;
